import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const DefaultValues = lazyWithChunkReload(() =>
  import("./calculation-defaults.main").then((m) => ({ default: m.DefaultValues }))
);
